import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { getEstablecimientoLS } from '@/shared/helpers/dataLocalStorage';
import { getAtencionById } from './getAtencionById';
import { getByToken } from './getByToken';
import { fieldsAtencion } from './fieldsAtencion';
import { MEDICO_DERIVACIONES } from '../../../../shared/constants';


const getAllAtenciones = async ( params = {} ) => {

  const {
    busqueda, estadoRevision, establecimiento, 
    especialidad, page, pageSize, 
    excel_btn, pdf_btn, fechaDesde, fechaHasta, 
    idDoctor, idPaciente, excelImc, sinDiagnosticos, 
    porRevisar, idAtencion, tipoCobertura, segsalud,
    observaciones
  } = params;

  const query = `
    query qrallAtemedica(
      $busqueda        : String,
      $estadoRevision  : String, 
      $establecimiento : String,
      $especialidad    : String, 
      $page            : Int,
      $pageSize        : Int,
      $excel           : String, 
      $pdf             : String, 
      $fechaDesde      : String, 
      $fechaHasta      : String,
      $idDoctor        : ID,
      $idPaciente      : ID,
      $excelImc        : String,
      $sinDiagnosticos : String,
      $porRevisar      : String,
      $idAtencion      : ID,
      $tipoCobertura   : String,
      $segsalud        : ID,
      $observaciones   : String
    ){
      allAtenmedica(
        busqueda        : $busqueda,
        estadoRevision  : $estadoRevision, 
        establecimiento : $establecimiento,
        especialidad    : $especialidad, 
        excel           : $excel, 
        pdf             : $pdf, 
        page            : $page, 
        pageSize        : $pageSize,
        fechaDesde      : $fechaDesde, 
        fechaHasta      : $fechaHasta,
        idDoctor        : $idDoctor,
        idPaciente      : $idPaciente,
        excelImc        : $excelImc,
        sinDiagnosticos : $sinDiagnosticos,
        porRevisar      : $porRevisar,
        idAtencion      : $idAtencion,
        tipoCobertura   : $tipoCobertura,
        segsalud        : $segsalud
        observaciones   : $observaciones
      ) {
        atcm {
          ${fieldsAtencion}
        }
        dataarchivo
        total
        status
        message
      }
    }
  `;
  const variables = {
    busqueda       : busqueda,
    estadoRevision : estadoRevision,
    establecimiento: establecimiento,
    especialidad   : especialidad,
    excel          : excel_btn,
    pdf            : pdf_btn,
    page           : page,
    fechaDesde     : fechaDesde,
    fechaHasta     : fechaHasta,
    pageSize       : pageSize,
    idDoctor       : idDoctor,
    idPaciente     : idPaciente,
    excelImc       : excelImc,
    sinDiagnosticos: sinDiagnosticos,
    porRevisar     : porRevisar,
    idAtencion     : idAtencion,
    tipoCobertura  : tipoCobertura,
    segsalud       : segsalud,
    observaciones  : observaciones
  }
  try {

    const response = await axios.post(rutas.axios + 'api', { query, variables });

    const response2 = response.data.data.allAtenmedica;
    if( response2.status !== "success") return null;

    const data = {
      atenciones : response2.atcm,
      total      : response2.total,
      dataArchivo: response2.dataarchivo,
    }

    return data;

  } catch (error) {
    console.error("Error fetching laboratorio:", error);
    return error;
  }
}


const getAllAtencionesByPaciente = async ( idPaciente ) => {

  if( !idPaciente ) return null;

  const query = `
    query qrallAtemedica(
      $idPaciente: ID,
    ){
      allAtenmedica(
        idPaciente: $idPaciente,
      ) {
        atcm {
          ${fieldsAtencion}
        }
        dataarchivo
        total
        status
        message
      }
    }
  `;
  const variables = {
    idPaciente,
  }

  try {

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if( response.status !== 200 ) return null;

    const response2 = response.data.data.allAtenmedica;
    if( response2.status !== "success") return null;

    const atencionesNoServicios = response2.atcm.filter( atencion => atencion.cita.doctor.id !==  MEDICO_DERIVACIONES.IMAGENES);

    const data = {
      atenciones : atencionesNoServicios,
      total      : atencionesNoServicios?.length,
      dataArchivo: response2.dataarchivo,
    }

    return data;

  } catch (error) {
    console.error("Error fetching laboratorio:", error);
    return null;
  }
}


const updateByToken = async (tokenAtencion, fields) => {

  const query = `
    mutation UpdateAtencionMedica(
      $tokenAtencion : String!
      $estadoRevision: String
      $signature     : String
      $semiologia    : String
      $codderivacion : String
    ) {
      updateAtencionMedica(
        tokenAtencion    : $tokenAtencion, 
        estadoRevision   : $estadoRevision
        signature        : $signature
        semiologia       : $semiologia
        codderivacion    : $codderivacion
      ) {
        consultaCitaMedica {
          token
          id
        }
      }
    }
  `;

  const variables = {
    tokenAtencion,
    ...fields
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.updateAtencionMedica;

    if(!response2) return null;
    if(!response2.consultaCitaMedica) return null;

    const data = response2.consultaCitaMedica.token;
    return data;

  }catch(error){
    console.error("Error al actualizar la atención:", error);
    return null;
  }
}


const uploadConsentimiento = async (tokenAtencion, urlConsentimiento) => {

  const query = `
    mutation UploadFileConsentimiento(
      $tokenAtencion:String!
      $urlConsentimiento:String!
    ) {
      uploadFileConsentimiento(
        tokenAtencion: $tokenAtencion, 
        urlConsentimiento: $urlConsentimiento
      ) {
        atencionMedica {
          id
          token
          urlConsentimiento
        }

        status
        message
      }
    }

  `;

  const variables = {
    tokenAtencion,
    urlConsentimiento
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });  
    if(response.status !== 200) return null;

    const response2 = response.data.data.uploadFileConsentimiento;
    if(response2.status !== "success") return null;

    const data = response2.atencionMedica;
    return data;

  }catch(error){
    console.error("Error al actualizar el consentimiento:", error);
    return null;
  }

}


const getItemsObservaciones = async (params) => {

  const { tipoObservacion, doctor = null, page = 1, pageSize = 15 } = params;

  const query = `
    query ObservacionesItemsAtenciones(
      $establecimiento: ID
      $tipoObservacion: String
      $doctor: ID
      $page: Int
      $pageSize: Int
    ) {
      observacionesItemsAtenciones(
        establecimiento: $establecimiento
        tipoObservacion: $tipoObservacion
        doctor: $doctor
        page: $page
        pageSize: $pageSize
      ) {
        status
        total
        atenciones{
          ${fieldsAtencion}
        }
      }
    }
  `;

  const establecimiento = getEstablecimientoLS();

  const variables = {
    establecimiento: establecimiento.id,
    tipoObservacion,
    doctor,
    page,
    pageSize
  }


  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.observacionesItemsAtenciones;
    if(response2.status !== "success") return null;

    const data = {
      atenciones: response2.atenciones,
      total: response2.total,
      dataArchivo: null
    }

    console.log('data', data);

    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
} 


const getPacienteDoctorEstab = async ( idAtencion ) => {

  const query = `
    query GetAtencionId($idAtencion:String!) {
      getAtencionId(idAtencion:$idAtencion ) {
        status
        message
        atencionMedica {
          id
          cita {
            id
            token
            fechaCita
            paciente {
              id
              token
              persona {
                primerNombre
                segundoNombre
                primerApellido
                segundoApellido
                identificacion
                tipoIdentificacion
                sexo
                fechaNacimiento
                esDiscapacitado
              }
            }
            doctor {
              id
              token
              idPersona {
                primerNombre
                segundoNombre
                primerApellido
                segundoApellido
                identificacion
              }
            }
            establecimiento {
              id
              Descripcion
            }
          }
        }
      }
    }
  `;

  const variables = { idAtencion };

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    const response2 = response.data.data.getAtencionId;

    if (response2.status !== 'success') return null;
    const data = response2.atencionMedica.cita;
    return data;
    
  } catch (error) {
    console.error("Error fetching data atencion:", error);
    return null;
  }
}


export const atencionMedicaService = {
  getAllAtenciones,
  getAllAtencionesByPaciente,
  getAtencionById,
  getByToken,

  getItemsObservaciones,

  updateByToken,
  uploadConsentimiento,

  getPacienteDoctorEstab
}